import API from './api'
import Request from './http'

export const get = {
  /**
   * 获取文书模板
   * @param params
   * @returns {*|Promise<any>}
   */
  getDocModuleList: function (params) {
    return Request.get(API.API_DOC_MODULE, params)
  },

  /**
   * 获取用户信息
   * @param params
   * @returns {*|Promise<any>}
   */
  getUserInfo: function () {
    return Request.get(API.API_GET_USER_INFO)
  },
  /**
   * 获取产品评论
   * @param params
   * @returns {*|Promise<any>}
   */
  getProductRate: function (id) {
    return Request.get(`${API.API_GET_PRODUCT_RATE}/${id}`)
  },
  /**
   * 获取订单
   */
  getorderType: function () {
    return Request.get(API.API_ORDER_TYPE)
  },

  /**
   * 获取订单动态
   */
  orderDynamic: function () {
    return Request.get(API.API_ORDER_DYNAMIC)
  },

  /**
   * 获取产品详情
   */
  docDetail: function () {
    return Request.get(API.API_DOC_PARAMS)
  },

  /**
   * 获取未接通原因调查问题
   */
  getUnlinkreason: function (params) {
    return Request.get(API.API_UNLINK_REASON, params)
  },
  /**
   * 获取评价标签
   */
  getEvalTag: function (params) {
    return Request.get(API.API_EVAL_TAG, params)
  },
  /**
   * 发律师函详情
   */
  getletterDetail: function (params) {
    return Request.get(API.API_LETTER_ORODER, params)
  },

  /**
   * 见面咨询详情
   */
  getFaceDetail: function (params) {
    return Request.get(API.API_FACE_ORDER, params)
  },

  /**
   * 代打官司详情
   */
  getLawsuitDetail: function (params) {
    return Request.get(API.API_LAWSUIT, params)
  },

  /**
   * 律师审核
   */
  getDraftDetail: function (params) {
    return Request.get(API.API_DRAFT_DDETAIL, params)
  },
  /**
   * 取消订单
   */
  cancelOrder: function (params) {
    return Request.get(API.API_CANCEL_ORDER, params)
  },

  /*
   * 获取产品价格
   */
  getPrice: function (params) {
    return Request.get(API.API_PRODUCE_PRICE, params)
  },
  /*
   * 检测三要素
   */
  getThreeElements: function (params) {
    return Request.get(API.API_GET_USER_CHECK_THREE_ELEMENTS, params)
  },
  /**
   *律师起草下单
   */
  getProducts: function (params) {
    return Request.get(API.API_PRODUCTS, params)
  },
  /**
   *商城配置
   */
  getShopList: function (params) {
    return Request.get(API.API_SHOP_LIST, params)
  },

  cancelCallOrder: function (params) {
    return Request.get(API.API_Cancel_CallOrder, params)
  }
  
}
export default get



// WEBPACK FOOTER //
// ./src/libs/request/get.js